import { DocumentLanguage, TargetAudienceThingJson, BrandVoiceThingJson, Template } from "./article";
import { topicIdea } from "./topic";
import { LayoutColumnDefinition } from "./layout-content";

export interface TopicIdeaPayloadForAIGenerationType {
  topicIdea: topicIdea;
  language: string;
  tone: string;
  contentBrief: string;
  gender: string;
  ageGroup: string;
  interestAndPersona: string;
  brandVoiceDocument: string;
  isOutlineCreation: boolean;
  isGenericFlow: boolean;
  templateId: number;
  templateTitle: string;
  inputText: string;
  titleText: string;
  placeholderText: string;
  contentBriefText: string;
  isPublishable: boolean;
  hideChangeWorkflow: boolean;
  geoRecommendationId?: string;
  knowledgeChunkData?: string ;
  isKnowledgeVaultEnable?: boolean;
  prompts?: string[];
}

export class TopicIdeaPayloadForAIGeneration {
  topicIdea: topicIdea = new topicIdea();
  language: string = "";
  tone: string = "";
  contentBrief: string = "";
  gender: string = "";
  ageGroup: string = "";
  interestAndPersona: string = "";
  brandVoiceDocument: string = "";
  targetAudienceDetails: TargetAudienceThingJson;
  brandVoiceDetails: BrandVoiceThingJson;
  isOutlineCreation: boolean = false;
  isGenericFlow: boolean = false;
  HighlightedTextOrCustomPrompt: string = "";
  isExpand: boolean = false;
  isParaphrase: boolean = false;
  isChangeVoice: boolean = false;
  isCustomCommand: boolean = false;
  languageDetail: DocumentLanguage;
  templateId: number;
  targetAudienceId: number;
  brandVoiceId: number;
  templateTitle: string;
  inputText: string;
  titleText: string;
  placeholderText: string;
  contentBriefText: string;
  isPublishable: boolean;
  hideChangeWorkflow: boolean;
  recreateContentDocument: string = "";
  campaignGoal?: string = "";
  campaignTopic?: string = "";
  campaignId?: string = "";
  isFaqWorkflow:boolean = false;
  isCustomTemplateWorkflow:boolean = false;
  isYoutubeSummaryTemplateWorkflow:boolean = false;
  serviceName?: string = "";
  projectType?: string = "";
  contentOutlineGoal?: string = "";
  PageUrls: string[] = [];
  isParentUrl:boolean = false;
  isRegenerateRequest: boolean = false;
  isRegenerateFlow: boolean = false;
  isStreamFlow: boolean = false;
  geoRecommendationId?: string = null;
  knowledgeChunkData?: string = null;
  isKnowledgeVaultEnable: boolean = false;
  prompts: string[] = [];
  // "Add A Layout" column generation - the preset the editor just inserted plus the
  // article context it landed in. See ArticleService.generateLayoutContent().
  isLayoutGeneration: boolean = false;
  layoutName?: string = "";
  layoutColumns?: LayoutColumnDefinition[] = [];
  articleTitle?: string = "";
  articleContext?: string = "";
  // Every template picked in the Select Templates step - one article is generated per entry.
  selectedTemplates: Template[] = [];
  // Existing article context for the Custom Command prompt, so the instruction is executed against
  // the article on screen instead of in isolation.
  metaTitle: string = "";
  metaDescription: string = "";
  keyphrase: string = "";
  articleBody: string = "";
}
